import { DOCUMENT_UPLOAD } from '../Config/Config';

export function validateSpace(value) {
    if (!value.replace(/\s/g, '').length) {
        return false;
    }
    return true;
}
export function validateNull(value) {
    if (value !== "") {
        return true
    }
    return false
}
export function validateEmail(value) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).toLowerCase());
}
export function isNumber(value) {
    const re = /^\d+$/;
    return re.test(value)
}

// Retourne un message d'erreur si le fichier ne respecte pas les règles d'envoi de documents, sinon null
export function validateDocumentFile(file) {
  const {
    maxSizeBytes,
    maxSizeLabel,
    allowedExtensions,
    allowedMimeTypes,
    formatsLabel
  } = DOCUMENT_UPLOAD;
  const name = file?.name ?? '';
  const extension = name.includes('.')
    ? name.split('.').pop().toLowerCase()
    : '';
  const mimeType = (file?.type ?? '').toLowerCase();
  // Le type MIME n'est pas toujours renseigné par le navigateur : il n'est contrôlé que s'il est disponible
  if (
    !allowedExtensions.includes(extension) ||
    (mimeType && !allowedMimeTypes.includes(mimeType))
  ) {
    return `Format non accepté. Formats autorisés : ${formatsLabel}.`;
  }
  if (file.size > maxSizeBytes) {
    return `Le fichier dépasse la taille maximale de ${maxSizeLabel}.`;
  }
  return null;
}
